<template lang="pug">
	b-card.custom-overlay-card(:img-src='_post.image||imgDefault' :img-alt='_post.title' text-variant='white')
		b-card-title(style="margin-top:6rem;")
			router-link.text-overflow-4(:to="postLinkUrl" style="color: inherit; max-height:100px;") {{ _post.title }}
		b-card-text.text-overflow-5(v-html="_post.short" style="max-height:100px;") {{ _post.short }}
		b-card-text.mt-2
			.badge-list
				b-badge.badge-list__badge(v-for="tag in filteredTags(_post.tag)" :variant="activeTag===tag.id ? 'success':'light'" href="#" @click="tagClick(tag.id)"  :key="tag.id") {{ tag.title }}
				b-badge.badge-list__badge(variant="info" href="#" @click="maxTags=maxTags?0:3" v-if="_post.tag.length >maxTags") {{ maxTags ? '...' : 'скрыть' }}
		b-card-text.g-between-center
			router-link(:to="postLinkUrl" style="color: inherit;") Подробнее
			div.d-flex.align-items-center
				div.like.mr-3(v-if="_post.comment_count")
					span.like__counter {{ _post.comment_count || '' }}
					i.fa.fa-lg.fa-comment-o
				like(:_active="_post.liked" :_count="_post.likes" :_contentName="'post'" :_contentID="_post.id")
</template>

<script>
	import { mapState } from 'vuex'

	import like from '../like'


	export default {
		name: 'PostCard',
		props: ['_post','_baseUrl'],
		components: {like},
		data: () => ({
			imgDefault: '/img/img-news-default.png',
			transition: 'slide-right',
			maxTags: 3,
		}),
		computed: {
			...mapState(['post']),

			activeTag(){ return this.$parent.search ? parseInt(this.$parent.search.tag) : undefined; },
			postLinkUrl(){ return `${this._baseUrl}/${this._post.id}` }
		},
		methods: {
			filteredTags(tags){
				return tags.filter((item,i)=>this.maxTags ? i<this.maxTags : true)
			},
			tagClick(id){
				this.$parent.search.tag = this.activeTag === id ? null : id;
			}
		},
	}
</script>
